import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchContraEntryList = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/contraEntry/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            commit('setContraEntryList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number, total_amount: res.data.total_amount})
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchContraEntryData = ({commit}, payload) => {
   
    commit('toggleLoadingState', true)
    axios.post('/contraEntry/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(payload.copy) {
            res.data.response.id = 0
            commit('displaySuccessNotification', {message: 'Data copied!!!'});
        }

        if(res.data.status) {
            
            commit('setContraEntryData', res.data.response)   
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetContraEntryData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitContraEntryData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/contraEntry/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteContraEntryData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/contraEntry/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchContraEntryList', payload.list)
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/contraEntry/actions.js